// A 1-5 rating -> a row of ★ (filled / half / empty) plus the numeric average and count. Shared
// by the trending strip (App.js) and every global-search result row (SearchExperience.js).
export default function StarRating({ avg, count, className = '' }) {
  if (!avg) return null;
  const rounded = Math.round(avg * 2) / 2;
  return (
    <span
      className={`rv-stars ${className}`.trim()}
      title={`${avg.toFixed(1)} out of 5${count ? ` (${count} rating${count === 1 ? '' : 's'})` : ''}`}
    >
      {[1, 2, 3, 4, 5].map((n) => (
        <span key={n} className="rv-star" aria-hidden="true">
          {rounded >= n ? '★' : rounded >= n - 0.5 ? '⯪' : '☆'}
        </span>
      ))}
      <span className="rv-stars-count">{avg.toFixed(1)}{count ? ` (${count})` : ''}</span>
    </span>
  );
}
